export const dataTableFooterProps = {
  "items-per-page-options": [10, 20, 30, 40, 50],
};
export const dataTableNoDataText = "ไม่มีข้อมูล";
export const dataTableLoadingText = "กำลังดึงข้อมูล...";

// MARKER
export const CHECKPOINT_DURATION_INTERVAL = 10;
